/**
 *
 * InvoiceDetailActionBar
 *
 */

import * as React from 'react';
import { useEffect } from 'react';

// ui
import { Button, IconButton, Flex } from '@domonda/ui';
import { IconButton as MUIIconButton } from '@material-ui/core';
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import * as Icons from 'lib/domonda-icons';
const mime = require('mime-types');


export interface InvoiceDetailActionBarProps {
  fullscreen: boolean;
  onTriggerFullscreen: () => void;
  outlined: boolean;
  onTriggerOutlined: () => void;
  magnifier: boolean;
  onTriggerMagnifier: () => void;
  lassoMode: boolean;
  onTriggerLassoMode: () => void;
  downloadUrl: string;
  downloadFileName: string;
  onDelete: () => void;
  prevContainerUrl: string;
  nextContainerUrl: string;
  closeContainerUrl: string;
  onZoomInTrigger: (e: any) => void;
  onZoomOutTrigger: (e: any) => void;
  saving: boolean;
  onSave: () => void;
  showRemove: boolean;
  invoiceState: any;
  detectInvoiceResponse?: any;
}

export const InvoiceDetailActionBar: React.FC<InvoiceDetailActionBarProps> = (props) => {
  const {
    lassoMode,
    onTriggerLassoMode,
    outlined,
    showRemove,
    onTriggerOutlined,
    onZoomInTrigger,
    onZoomOutTrigger,
    downloadUrl,
    onDelete,
    onSave,
    detectInvoiceResponse,
  } = props;

  const handleKeyDown = (e: React.KeyboardEvent<Element>) => {
    if (e.keyCode === 13 && e.ctrlKey) {
      onSave();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown as any);
    return () => {
      document.removeEventListener('keydown', handleKeyDown as any);
    };
  }, []);

  const handleDownloadClick = async (_e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const response = await fetch(downloadUrl);
    const responseJSON = await response.json();
    const mimeFileType = mime.lookup(responseJSON.FileName);
    const base64Response = await fetch(`data:${mimeFileType};base64,${responseJSON.FileContent}`);
    const blob = await base64Response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = responseJSON.FileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  function jsonSyntaxHighlight(json) {
    if (typeof json != 'string') {
      json = JSON.stringify(json, undefined, 2);
    }
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
      var cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    });
  }

  const handleJsonClick = async (_e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const responseJSON = detectInvoiceResponse;
    const jsonTab = window.open('about:blank', '_blank');
    jsonTab.document.write(
      `<style>
         pre { padding: 5px; margin: 5px; }
         .string { color: green; }
         .number { color: darkblue; }
         .boolean { color: blue; }
         .null { color: magenta; }
         .key { color: gray; }
       </style>
       <pre>${jsonSyntaxHighlight(JSON.stringify(responseJSON, null, 2))}</pre>
    `);
    jsonTab.document.close();
  };

  return (
    <Flex container spacing={1} align="center" direction="column">
{/*
      <Flex item>
        <IconButton color={fullscreen ? 'primary' : undefined} onClick={onTriggerFullscreen}>
          {fullscreen ? <Icons.FullscreenExit /> : <Icons.Fullscreen />}
        </IconButton>
      </Flex>
*/}
      <Flex item>
        <IconButton color={outlined ? 'primary' : undefined} onClick={onTriggerOutlined}>
          {outlined ? <Icons.GridOff /> : <Icons.GridOn />}
        </IconButton>
      </Flex>
      <Flex item style={{ display: 'none' }}>
        <Button color={lassoMode ? 'primary' : undefined} onClick={onTriggerLassoMode}>
          {lassoMode ? <CenterFocusStrongIcon /> : <CenterFocusWeakIcon />}
        </Button>
      </Flex>
      <Flex item>
        <MUIIconButton onClick={onZoomInTrigger}>
          <Icons.ZoomInDocument />
        </MUIIconButton>
      </Flex>
      <Flex item>
        <MUIIconButton onClick={onZoomOutTrigger}>
          <Icons.ZoomOutDocument />
        </MUIIconButton>
      </Flex>
      <Flex item>
        <IconButton
          component={(props) => (
            <button {...props} onClick={handleJsonClick}>
              <Icons.Json />
            </button>
          )}
        />
      </Flex>
{/*
      <Flex item>
        <IconButton
          component={(props) => (
            <button {...props} onClick={handleDownloadClick}>
              <Icons.DownloadDocument />
            </button>
          )}
          // component={(props) => (
          //   <a {...props} href={downloadUrl} download={downloadFileName}>
          //     <Icons.DownloadDocument />
          //   </a>
          // )}
        />
      </Flex>
      {showRemove && (
        <Flex item>
          <IconButton color="error" onClick={onDelete}>
            <Icons.RemoveDocument />
          </IconButton>
        </Flex>
      )}
      <Flex item flex={1} />
      <Flex item>
        <IconButton disabled={!prevContainerUrl} component={makeLink({ to: prevContainerUrl })}>
          <Icons.PreviousDocument />
        </IconButton>
      </Flex>
      <Flex item>
        <IconButton disabled={!nextContainerUrl} component={makeLink({ to: nextContainerUrl })}>
          <Icons.NextDocument />
        </IconButton>
      </Flex>
      <Flex item>
        <IconButton component={makeLink({ to: closeContainerUrl })}>
          <Icons.CloseDocument />
        </IconButton>
      </Flex>
      <Flex item>
        <ValidateButton
          tabIndex={3}
          onClick={onSave}
          disabled={saving || errorCount > 0 || invoiceState === 'Confirmed' ||
            invoiceState === 'Deleted' || invoiceState === 'Autoprocessed' || invoiceState === 'Downloaded' || invoiceState === 'New' ||
            invoiceState === 'Released'
          }
        >
          {saving ? (
            <FormattedMessage id="VALIDATING">{(text) => `${text}...`}</FormattedMessage>
          ) : (
            <>
              <Icons.ApproveDocument />
              &nbsp;
              <FormattedMessage id="VALIDATE" />
            </>
          )}
        </ValidateButton>
      </Flex>
*/}
    </Flex>
  );
};


